import { useContext, useEffect, useState } from "react";
import { tokenContext } from '../componentes/TokenContext';
import axios from 'axios';

export const useOffers = () => {
    const {token} = useContext(tokenContext);
    const tok = token;
    const [ofertas, setOfertas] = useState({
        loaded:false,
        ofertas: null,
        error:null,
    });


      const getTakito = () => {  
        const rumpelstinki =  {
             "urombrett": "pibe4353fdas",
             "contwyerr": "engyr533hrr5"
           }
       
         let result = axios.post(`/ohaurlisrp/nteragyuytil/`, rumpelstinki)
         .then(response => {
             return response.data;
             })
             .catch((error) => {
                
                 return error.response;
             });
              //console.log('topuptkServices: ', result);
             return result;
     }

  const getOfertas = async() => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `promotion/consultOffer/${token}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
       axios.post(`/webservice/goapimicrositio`, request, config)
        .then(response => {
            //console.log(response);
            setOfertas({
                loaded: true,
                ofertas: response,
                status:response.status
            });
        })
        .catch((error) => {
            //console.log(error);
            setOfertas({
                loaded: true,
                error:{ errorMessage: error.message },
                ofertas: null,
            });
        });
    };
    
    useEffect(() => {
        getOfertas();
    }, [tok]);

    return  ofertas;
}
